export const EMPOWER_MODULE='EMPOWER_MODULE';
export const EMPOWER_REPORT_PAGE = `${EMPOWER_MODULE}_REPORT_PAGE`;
export const EMPOWER_REPORT_PAGE_MODERN_LIFE = `${EMPOWER_MODULE}_REPORT_PAGE_MODERN_LIFE`;
export const EMPOWER_REPORT_PAGE_GAMMING = `${EMPOWER_MODULE}_REPORT_PAGE_GAMMING`;
export const EMPOWER_REPORT_EXPORT = `${EMPOWER_MODULE}_REPORT_EXPORT`;
export const PPT = `PPT`;
export const PDF = `PDF`;
export const INSIGHT_QUERY_DOMAIN_CODE = `ORIGN`;
export const INSIGHT_QUERY_TEAM_CODE = `TEAMS`;
export const INSIGHT_QUERY_USER_CODE = `EMAIL`;
export const INSIGHT_QUERY_REPORT_CODE = `RPRT`;
export const INSIGHT_QUERY_DATA_CODE = `DASH`;
export const INSIGHT_QUERY_COUNT_CODE = `COUNT`;
export const INSIGHT_QUERY_ROLES_CODE = `ROLES`;
export const INSIGHT_QUERY_PAGE_CATEGORY_CODE = `PGCAT`;
export const INSIGHT_QUERY_PARTNER_CODE = `PRTNR`;
export const INSIGHT_QUERY_NAME_CODE = `FNAME`;
export const INSIGHT_QUERY_COUNTRY_CODE = `CNTRY`;
